export default __webpack_public_path__ + "static/media/Banner - Elevate Pro - Diamond Blue.af262c1c.jpg";